import { createContext } from 'react';

import type { IConfirmDialogOptions, IConfirmDialogResult } from './types';

export default createContext<(options: IConfirmDialogOptions) => Promise<IConfirmDialogResult>>(
  Promise.reject
);
